<template>
  <div class="subscription-packages">
    <div class="subscription-package">
      <div class="subscription-package__dots">
        <div class="subscription-dot" />
      </div>
      <div class="subscription-package__item">
        <label>Products</label>
        <div class="subscription-package__item__tags">
          <span
            v-if="hasPermission('articles.view')"
            class="bg-light p-1 mr-1 mb-1"
          >
            All
          </span>
          <span
            v-else
            v-for="(permission, index) in filteredPermissions('App\\Models\\Product')"
            :key="index"
            class="bg-light p-1 mr-1 mb-1"
          >
            {{ permission.entitlement.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="subscription-package">
      <div class="subscription-package__dots">
        <div class="subscription-dot" />
      </div>
      <div class="subscription-package__item">
        <label>Regions</label>
        <div class="subscription-package__item__tags">
          <span
            v-if="hasPermission('articles.view')"
            class="bg-light p-1 mr-1 mb-1"
          >
            Global
          </span>
          <span
            v-else
            v-for="(permission, index) in filteredPermissions('App\\Models\\Region')"
            :key="index"
            class="bg-light p-1 mr-1 mb-1"
          >
            {{ permission.entitlement.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="subscription-package">
      <div class="subscription-package__dots">
        <div class="subscription-dot" />
      </div>
      <div class="subscription-package__item">
        <label>Providers</label>
        <div
          class="subscription-package__item__tags"
        >
          <span
            v-if="hasPermission('view.articles.channel.*') || hasPermission('articles.view')"
            class="bg-light p-1 mr-1 mb-1"
          >
            All
          </span>
          <span
            v-else-if="hasPermission('articles.view.channel')"
            class="bg-light p-1 mr-1 mb-1"
          >
            User's associated providers
          </span>
          <span
            v-else
            v-for="(permission, index) in filteredPermissions('App\\Models\\Channel')"
            :key="index"
            class="bg-light p-1 mr-1 mb-1"
          >
            {{ permission.entitlement.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="subscription-package">
      <div class="subscription-package__dots">
        <div class="subscription-dot" />
      </div>
      <div class="subscription-package__item">
        <label>Enterprise</label>
        <div
          class="subscription-package__item__tags"
          v-if="hasPermission('admin.login')"
        >
          <span
            v-for="(permission, index) in enterprisePermissions"
            :key="index"
            class="bg-light p-1 mr-1 mb-1"
          >
            {{ fancyName(permission.name) }}
          </span>
        </div>
        <span
          v-else
          class="bg-light p-1 mr-1 mb-1"
        >
          No access
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    permissions: {
      required: true,
      type: Array,
    },
  },
  computed: {
    allChannels () {
      return this.hasPermission('view.articles.channel.*')
    },

    enterprisePermissions () {
      return this.permissions.filter((v) => !v.entitlement)
    },
  },

  methods: {
    filteredPermissions (type) {
      return this.permissions.filter((permission) => permission.entitlement_type === type)
    },
    hasPermission (name) {
      return !!this.permissions.find((permission) => permission.name === name)
    },

    fancyName (name) {
      return name.replace(/[.-]/g, ' ').replace(/^[a-z]/, (match) => {
        return match.toUpperCase()
      }).replace(/\s[a-z]/g, (match) => {
        return match.toUpperCase()
      })
    },
  },
}
</script>

<style lang="scss">
.subscription-packages {
  margin-top: 1rem;
}

.subscription-package {
  display: flex;
  padding-bottom: 1rem;
  margin-bottom: 2px;

  &__dots {
    width: 24px;
    display: flex;
    flex-direction: column;
    .subscription-dot {
      height: calc(50% - 2px);
      border-bottom: 2px dotted #dfe2ee;
    }
  }

  &:last-child {
    .subscription-dot {
      height: calc(50% - 2px);
      border-bottom: 2px dotted #dfe2ee;
      border-left: 2px dotted #dfe2ee;
    }
  }

  &:not(:last-child) {
    border-left: 2px dotted #dfe2ee;
  }

  &__item {
    width: 100%;
    padding: 1rem;
    border: 1px solid #dfe2ee;
    border-radius: 4px;
    background: transparent;

    label {
      font-size: 16px;
      font-weight: bold;
    }

    &__tags {
      margin-top: 1rem;
      display: flex;
      flex-flow: row wrap;
      span {
        height: 24px;
        margin-right: 8px;
        padding-left: 8px;
        padding-right: 6px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 2px;
        background-color: #f0f2f9;
        border: 1px solid #dfe2ee;
      }
    }
  }
}
</style>

